import React from "react";
import { BsCalendarCheckFill } from "react-icons/bs";
import { MdSms } from "react-icons/md";
import { AiFillPhone } from "react-icons/ai";

export default function StickyMobileFooter() {
  return (
    <div className="fixed bottom-0 z-30 w-full md:hidden">
      {/* Gradient overlay for depth */}
      <div className="absolute inset-x-0 bottom-full h-8 bg-gradient-to-t from-white/80 to-transparent backdrop-blur-sm" />

      <div className="flex h-20 w-full items-stretch overflow-hidden bg-white shadow-2xl shadow-gray-900/20 ring-1 ring-gray-100">
        {/* Schedule Button */}
        <a
          href="/contact"
          className="group relative flex flex-1 flex-col items-center justify-center gap-1.5 overflow-hidden border-r border-gray-100 transition-all duration-300 active:scale-95"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-[#457B9D]/0 to-[#457B9D]/0 transition-all duration-300 group-hover:from-[#457B9D]/10 group-hover:to-[#457B9D]/5" />
          <BsCalendarCheckFill className="relative z-10 text-2xl text-[#457B9D] transition-transform duration-300 group-hover:scale-110 group-active:scale-95" />
          <span className="relative z-10 text-xs font-medium text-gray-700">
            Schedule
          </span>
        </a>

        {/* Text Button */}
        <a
          href="sms:+18707792229"
          className="group relative flex flex-1 flex-col items-center justify-center gap-1.5 overflow-hidden border-r border-gray-100 transition-all duration-300 active:scale-95"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-[#E8998D]/0 to-[#E8998D]/0 transition-all duration-300 group-hover:from-[#E8998D]/10 group-hover:to-[#E8998D]/5" />
          <MdSms className="relative z-10 text-3xl text-[#E8998D] transition-transform duration-300 group-hover:scale-110 group-active:scale-95" />
          <span className="relative z-10 text-xs font-medium text-gray-700">
            Text Us
          </span>
        </a>

        {/* Call Button */}
        <a
          href="tel:+18707792229"
          className="group relative flex flex-1 flex-col items-center justify-center gap-1.5 overflow-hidden transition-all duration-300 active:scale-95"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-[#457B9D]/0 to-[#457B9D]/0 transition-all duration-300 group-hover:from-[#457B9D]/10 group-hover:to-[#457B9D]/5" />
          <AiFillPhone className="relative z-10 text-3xl text-[#457B9D] transition-transform duration-300 group-hover:scale-110 group-active:scale-95" />
          <span className="relative z-10 text-xs font-medium text-gray-700">
            Call Now
          </span>
        </a>
      </div>
    </div>
  );
}
